<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
  props: {
    employeeData: {
      type: Object,
    },
  },
  data() {
    return {
      submitted: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false,
      }),
      tableData: [],
      employeeSelect: null,
      modalTitle: "",
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      form: {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: null,
        remarks: "",
      },
      campusId: this.$store.state.data.campus.id,
      employeeName: "",
      itemIndex: -1,
      tabIndex: 0,
      toggleAll: false,
      transferFrom: null,
      transferTo: null,
    };
  },
  validations: {
    form: {
      type: { required },
      reason: { required },
      transferToEmployeeId: { required },
    },
  },
  computed: {
    filtered() {
      let data = this.tableData;
      var total = this.currentPage * this.perPage;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.propertyAssignment.property.name
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          )
            return item.propertyAssignment.property.name
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (item.propertyAssignment.property.propertyNumber)
            if (
              item.propertyAssignment.property.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase())
            )
              return item.propertyAssignment.property.propertyNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            else if (item.reason)
              if (item.reason.toUpperCase().includes(this.filter.toUpperCase()))
                return item.reason
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
        });
      }
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
  },
  watch: {
    employeeData() {
      var firstname = this.employeeData.firstName;
      var lastname = this.employeeData.lastName;
      this.form.transferToEmployeeId = this.employeeData.idNo;
      this.employeeName = firstname.concat(" ", lastname);
    },
  },
  created() {},
  methods: {
    getData(employeeId) {
      this.employeeSelect = employeeId;
      if (this.tabIndex == 0) {
        this.getDraft();
      } else if (this.tabIndex == 1) {
        this.getPosted();
      } else if (this.tabIndex == 2) {
        this.getCompleted();
      }
    },
    getDraft() {
      if (this.employeeSelect != "") {
        this.loading = true;
        this.$store
          .dispatch(
            "propertytransfer/GetPropertyTransferDraftByEmployee",
            this.employeeSelect
          )
          .then((res) => {
            this.tableData = res.data.reverse();
            this.filter = "";
            this.loading = false;
          })
          .catch((err) => {
            let stringErr = err.toString();
            if (stringErr.includes("Network")) {
              this.showToast("Network Error!", "error");
            } else {
              this.showToast(
                "Something went wrong - Getting available items!",
                "error"
              );
            }
            this.loading = false;
          });
      }
    },
    getPosted() {
      if (this.employeeSelect != "") {
        this.loading = true;
        this.$store
          .dispatch(
            "propertytransfer/GetPropertyTransferPostedByEmployee",
            this.employeeSelect
          )
          .then((res) => {
            this.tableData = res.data.reverse();
            this.filter = "";
            this.loading = false;
          })
          .catch((err) => {
            let stringErr = err.toString();
            if (stringErr.includes("Network")) {
              this.showToast("Network Error!", "error");
            } else {
              this.showToast(
                "Something went wrong - Getting draft items!",
                "error"
              );
            }
            this.loading = false;
          });
      }
    },
    getCompleted() {
      if (this.employeeSelect != "") {
        this.loading = true;
        this.$store
          .dispatch(
            "propertytransfer/GetPropertyTransferApprovedtByEmployee",
            this.employeeSelect
          )
          .then((res) => {
            this.tableData = res.data.reverse();
            this.filter = "";
            this.loading = false;
          })
          .catch((err) => {
            let stringErr = err.toString();
            if (stringErr.includes("Network")) {
              this.showToast("Network Error!", "error");
            } else {
              this.showToast(
                "Something went wrong - Getting draft items!",
                "error"
              );
            }
            this.loading = false;
          });
      }
    },
    onUpdate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showPermanentToast(
          "There are fields that require your attention.",
          "error"
        );
        return;
      } else {
        this.$store
          .dispatch("propertytransfer/UpdatePropertyTransfer", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.tableData.splice(this.itemIndex, 1, this.form);
            this.showToast("Successfully updated!", "success");
            this.onReset();
            this.$bvModal.hide("modal-update");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - Updating this request!",
              "error"
            );
          });
        this.submitted = false;
      }
    },
    updateItem(row) {
      this.onReset();
      this.itemIndex = this.tableData.findIndex((item) => item.id == row.id);
      this.form = cloneDeep(row);
      this.$store
        .dispatch("externalemployee/GetByEmployeeId", row.transferToEmployeeId)
        .then((res) => {
          this.employeeName = res.data.firstName.concat(" ", res.data.lastName);
        });
      this.modalTitle = "Update Request";
      this.$bvModal.show("modal-update");
    },
    postItem(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to post this request!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, post it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertytransfer/PostPropertyTransfer", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex(
                (item) => item.id == row.id
              );
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully posted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be posted!", "error");
            });
        }
      });
    },
    deleteItem(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertytransfer/DeletePropertyTransfer", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex(
                (item) => item.id == row.id
              );
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    showTransfer(row) {
      this.$store
        .dispatch(
          "externalemployee/GetByEmployeeId",
          row.propertyAssignment.employeeIdNumber
        )
        .then((res) => {
          this.transferFrom = res.data;
        });
      this.$store
        .dispatch("externalemployee/GetByEmployeeId", row.transferToEmployeeId)
        .then((res) => {
          this.transferTo = res.data;
        });
      this.modalTitle = "Transfer Detail";
      this.$bvModal.show("modal-transferDetail");
    },
    onReset() {
      this.form = {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: null,
        remarks: "",
      };
      this.employeeName = "";
      this.itemIndex = -1;
      this.submitted = false;
    },
    getEmployee() {
      this.$emit("getEmployee", "property-transfer");
    },
  },
};
</script>
<template>
  <div>
    <!-- Update Request -->
    <b-modal
      id="modal-update"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="onUpdate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('update')" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Employee..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.transferToEmployeeId.$error,
              }"
              v-model="employeeName"
            />
          </b-input-group>
          <div
            v-if="submitted && $v.form.transferToEmployeeId.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.transferToEmployeeId.required"
              >This value is required.</span
            >
          </div>
        </div>
        <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select
            class="form-select"
            :class="{
              'is-invalid': submitted && $v.form.type.$error,
            }"
            v-model="form.type"
          >
            <b-form-select-option value="" disabled
              >Select Type...</b-form-select-option
            >
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation"
              >Donation</b-form-select-option
            >
            <b-form-select-option value="Reassignment"
              >Reassignment</b-form-select-option
            >
            <b-form-select-option value="Relocate"
              >Relocate</b-form-select-option
            >
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div v-if="submitted && $v.form.type.$error" class="invalid-feedback">
            <span v-if="!$v.form.type.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="reason">Reason</label>
          <textarea
            id="reason"
            rows="2"
            v-model="form.reason"
            placeholder="Enter Reason..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.reason.$error,
            }"
            autocomplete="off"
          ></textarea>
          <div
            v-if="submitted && $v.form.reason.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.reason.required">This value is required.</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Update</button>
        </div>
      </form>
    </b-modal>
    <!-- Show Transfer -->
    <b-modal
      id="modal-transferDetail"
      :title="modalTitle"
      size="lg"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div
        v-if="transferFrom && transferTo"
        class="d-flex align-items-center justify-content-between"
      >
        <div style="width: 45%">
          From
          <hr />
          <div class="d-flex align-items-center">
            <div class="avatar-sm me-2">
              <span
                class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                >{{ transferFrom.firstName.charAt(0).toUpperCase()
                }}{{ transferFrom.lastName.charAt(0).toUpperCase() }}</span
              >
            </div>
            <div>
              <div class="mt-1">
                <h5 class="mb-0">
                  {{
                    transferFrom.lastName.charAt(0).toUpperCase() +
                    transferFrom.lastName.slice(1)
                  }},
                  {{
                    transferFrom.firstName.charAt(0).toUpperCase() +
                    transferFrom.firstName.slice(1)
                  }}
                  {{
                    transferFrom.middleName
                      ? `${transferFrom.middleName.charAt(0).toUpperCase()}.`
                      : ""
                  }}
                </h5>
              </div>
              <div>{{ transferFrom.idNo }}</div>
            </div>
          </div>
          <hr />
        </div>
        <i class="font-size-20 bx bxs-right-arrow bx-fade-right me-3 mt-3"></i>
        <div style="width: 45%">
          To
          <hr />
          <div class="d-flex align-items-center">
            <div class="avatar-sm me-2">
              <span
                class="avatar-title rounded-circle bg-soft bg-success text-white font-size-16"
                >{{ transferTo.firstName.charAt(0).toUpperCase()
                }}{{ transferTo.lastName.charAt(0).toUpperCase() }}</span
              >
            </div>
            <div>
              <div class="mt-1">
                <h5 class="mb-0">
                  {{
                    transferTo.lastName.charAt(0).toUpperCase() +
                    transferTo.lastName.slice(1)
                  }},
                  {{
                    transferTo.firstName.charAt(0).toUpperCase() +
                    transferTo.firstName.slice(1)
                  }}
                  {{
                    transferTo.middleName
                      ? `${transferTo.middleName.charAt(0).toUpperCase()}.`
                      : ""
                  }}
                </h5>
              </div>
              <div>{{ transferTo.idNo }}</div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </b-modal>
    <!-- Main -->
    <div class="row pt-2">
      <!-- Table Data -->
      <b-tabs content-class="text-muted" v-model="tabIndex" pills vertical>
        <!-- Draft -->
        <b-tab @click="getDraft()">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-circle-edit-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Draft</span>
          </template>
          <div
            v-if="tabIndex == 0"
            class="d-flex align-items-center justify-content-between"
          >
            <h5 class="mb-0">List of Draft Request</h5>
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Property..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <div class="card-body ps-0 pe-0">
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="filtered.length == 0">
              <div v-if="!employeeSelect">
                <i class="fas fa-exclamation-triangle me-2"></i>Select an
                employee
              </div>
              <div v-else-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                items matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No transfers
                drafted
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h6 class="text-muted m-0" style="width: 200px">
                      Item Name
                    </h6>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <h6 class="text-muted m-0" style="width: 180px">Type</h6>
                      <h6 class="text-muted m-0" style="width: 200px">
                        Reason
                      </h6>
                      <h6
                        class="text-muted text-center m-0"
                        style="width: 120px"
                      >
                        Action
                      </h6>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in filtered" :key="x.id">
                <b-card
                  no-body
                  class="m-0 mb-3"
                  style="min-width: fit-content"
                  :style="`z-index: ${filtered.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="d-flex justify-content-between">
                      <div style="min-width: 200px">
                        <h5 class="m-0">
                          {{ x.propertyAssignment.property.name }}
                        </h5>
                        <small
                          >Property#
                          {{ x.propertyAssignment.property.propertyNumber }}
                          <span class="ms-2">
                            |
                            <a
                              href="javascript: void(0);"
                              class="ms-1"
                              @click="showTransfer(x)"
                            >
                              Show Transfer
                            </a>
                          </span>
                        </small>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div style="min-width: 180px">
                          {{ x.type }}
                        </div>
                        <div style="min-width: 200px">
                          {{ x.reason }}
                        </div>
                        <div
                          class="d-flex justify-content-center"
                          style="min-width: 120px"
                        >
                          <a
                            href="javascript:void(0);"
                            class="text-danger me-1"
                            @click="deleteItem(x)"
                            ><i class="bx bx-trash fs-2"></i
                          ></a>
                          <a
                            href="javascript:void(0);"
                            class="text-info me-1"
                            @click="updateItem(x)"
                            ><i class="bx bx-edit-alt fs-2"></i
                          ></a>
                          <a
                            href="javascript:void(0);"
                            class="text-success"
                            @click="postItem(x)"
                            ><i class="bx bx-check-circle fs-2"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Posted -->
        <b-tab @click="getPosted()">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-check-circle-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Posted</span>
          </template>
          <div
            v-if="tabIndex == 1"
            class="d-flex align-items-center justify-content-between"
          >
            <h5 class="mb-0">List of Posted Request</h5>
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Property..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <div class="card-body ps-0 pe-0">
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="filtered.length == 0">
              <div v-if="!employeeSelect">
                <i class="fas fa-exclamation-triangle me-2"></i>Select an
                employee
              </div>
              <div v-else-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                items matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No transfers
                posted
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h6 class="text-muted m-0" style="min-width: 200px">
                      Item Name
                    </h6>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <h6 class="text-muted m-0" style="min-width: 180px">
                        Type
                      </h6>
                      <h6 class="text-muted m-0" style="min-width: 200px">
                        Reason
                      </h6>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in filtered" :key="x.id">
                <b-card
                  no-body
                  class="m-0 mb-3"
                  style="min-width: fit-content"
                  :style="`z-index: ${filtered.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="d-flex justify-content-between">
                      <div style="min-width: 200px">
                        <h5 class="m-0">
                          {{ x.propertyAssignment.property.name }}
                        </h5>
                        <small
                          >Property#
                          {{ x.propertyAssignment.property.propertyNumber }}
                          <span class="ms-2">
                            |
                            <a
                              href="javascript: void(0);"
                              class="ms-1"
                              @click="showTransfer(x)"
                            >
                              Show Transfer
                            </a>
                          </span>
                        </small>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div style="min-width: 180px">
                          {{ x.type }}
                        </div>
                        <div style="min-width: 200px">
                          {{ x.reason }}
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- Completed -->
        <b-tab @click="getCompleted()">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="mdi mdi-check-circle-outline"></i>
            </span>
            <span class="d-none d-sm-inline-block">Completed</span>
          </template>
          <div
            v-if="tabIndex == 2"
            class="d-flex align-items-center justify-content-between"
          >
            <h5 class="mb-0">List of Completed Request</h5>
            <div class="d-flex">
              <div id="tickets-table_filter" class="dataTables_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Property..."
                    class="form-control"
                  ></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center mb-0">
                  <b-form-select
                    class="form-select"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  >
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <div class="card-body ps-0 pe-0">
            <b-card v-if="loading">
              <div class="d-flex align-items-center justify-content-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
            </b-card>
            <b-card class="text-center" v-else-if="filtered.length == 0">
              <div v-if="!employeeSelect">
                <i class="fas fa-exclamation-triangle me-2"></i>Select an
                employee
              </div>
              <div v-else-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                items matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No transfers
                completed
              </div>
            </b-card>
            <div v-else class="text-muted">
              <b-card no-body class="m-0 mb-3" style="min-width: fit-content">
                <b-card-header>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <h6 class="text-muted m-0" style="min-width: 200px">
                      Item Name
                    </h6>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <h6 class="text-muted m-0" style="min-width: 180px">
                        Type
                      </h6>
                      <h6 class="text-muted m-0" style="min-width: 200px">
                        Reason
                      </h6>
                    </div>
                  </div>
                </b-card-header>
              </b-card>
              <div role="tablist" v-for="(x, index) in filtered" :key="x.id">
                <b-card
                  no-body
                  class="m-0 mb-3"
                  style="min-width: fit-content"
                  :style="`z-index: ${filtered.length - index + 10}`"
                >
                  <b-card-header>
                    <div class="d-flex justify-content-between">
                      <div style="min-width: 200px">
                        <h5 class="m-0">
                          {{ x.propertyAssignment.property.name }}
                        </h5>
                        <small
                          >Property#
                          {{ x.propertyAssignment.property.propertyNumber }}
                          <span class="ms-2">
                            |
                            <a
                              href="javascript: void(0);"
                              class="ms-1"
                              @click="showTransfer(x)"
                            >
                              Show Transfer
                            </a>
                          </span>
                        </small>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div style="min-width: 180px">
                          {{ x.type }}
                        </div>
                        <div style="min-width: 200px">
                          {{ x.reason }}
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </b-card>
              </div>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
